import { cn } from "@/lib/utils";

type FileIconProps = {
  className?: string;
};

/** Untitled UI solid file icon (pdf). */
export function PdfFileIcon({ className }: FileIconProps) {
  return (
    <span className={cn("inline-flex size-8 shrink-0 text-violet-700 dark:text-violet-600", className)}>
      <svg fill="none" viewBox="0 0 40 40" aria-hidden className="size-full"><path fill="currentColor" d="M4 4a4 4 0 0 1 4-4h16l12 12v24a4 4 0 0 1-4 4H8a4 4 0 0 1-4-4z" /><path fill="#fff" d="m24 0 12 12h-8a4 4 0 0 1-4-4z" opacity=".3" /><path fill="#fff" d="M11.75 32v-6.546h2.582q.744 0 1.268.285.524.281.8.783.277.498.277 1.15 0 .653-.28 1.151a1.94 1.94 0 0 1-.816.777q-.53.278-1.285.278H12.65v-1.11h1.423q.399 0 .658-.137a.9.9 0 0 0 .39-.386q.13-.25.13-.572 0-.326-.13-.57a.88.88 0 0 0-.39-.38q-.262-.137-.665-.137h-.933V32zm8.147 0h-2.32v-6.546h2.339q.987 0 1.7.394.712.39 1.096 1.122.387.731.387 1.75 0 1.024-.387 1.759-.384.735-1.102 1.128-.717.393-1.713.393m-.937-1.186h.879q.614 0 1.032-.217.422-.22.633-.68.214-.464.214-1.196 0-.726-.214-1.186a1.4 1.4 0 0 0-.63-.677q-.418-.218-1.032-.218h-.882zM24.124 32v-6.546h4.334v1.142h-2.95v1.56h2.662v1.14h-2.662V32z" /></svg>
    </span>
  );
}
